module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-76x76-precomposed-7b497a1f017c6c2277cd178e7a515145.png";